import _ from 'lodash';

function TrainingCtrl($rootScope, $scope, $stateParams, toastr, AuthService, PlanService, PlayerService, AnalysisService, AppContextService) {
  'ngInject';

  var vm = this;
  vm.appContext = AppContextService.context;
  var plans;
  vm.mode = 'list';
  vm.year = $stateParams.year;
  vm.month = $stateParams.month;


  vm.monthRanges = _.range(1, 13).map(num => ('0' + num).slice(-2));

  // 부상 상황 변경
  $scope.$watch('game.year', function (newVal, oldVal) {
    if (newVal) {
      vm.filterGames();
    }
  });

  $scope.$watch('game.month', function (newVal, oldVal) {
    if (newVal) {
      vm.filterGames();
    }
  });

  vm.filterGames = function () {

    var check = (vm.year && vm.month) || (!vm.year && !vm.month);

    if (!check) {
      console.log('check ERROR...', check);
      return;
    }
    var yearMonth = '';
    if (vm.year && vm.month) {
      yearMonth = vm.year + '.' + vm.month;
    }

    // console.log('filter....', yearMonth);
    // console.log('filter....', _.filter(plans, {type:'경기'}));
    if (yearMonth) {
      var items = _.filter(plans, function (p) {
        return p.type === '경기' && p.date.startsWith(yearMonth)
      });
      vm.items = _.orderBy(items, ['id'], ['desc']);
    } else {
      var items = _.filter(plans, { type: '경기' });
      vm.items = _.orderBy(items, ['id'], ['desc']);
    }
  }

  vm.setToday = function () {
    vm.year = new Date().toISOString().slice(0, 4);
    vm.month = new Date().toISOString().slice(5, 7);
  }

  vm.createGame = function () {
    vm.appContext.players.game.my_team.entryMain = [];
    vm.appContext.players.game.my_team.entryBackup = [];
    vm.appContext.players.game.oppo_team.entryMain = [];
    vm.appContext.players.game.oppo_team.entryBackup = [];

    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(new Date() - tzoffset)).toISOString().slice(0, -5);
    var date = localISOTime.split("T")[0].split("-").join(".");
    var time = localISOTime.split("T")[1];
    // vm.appContext.gameDateTime = date + ' ' + time;
    // //vm.appContext.gameDateTime = '';

    vm.appContext.oppoTeam_id = '';

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: date,
      time: time
    };

    PlanService.setGame(data)
      .then(function (res) {
        $stateParams.game_id = res.data.game_id;
        $state.go('Service.gameDetail', { game_id: $stateParams.game_id, year: vm.year, month: vm.month })
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })







  }

  vm.remove = function (id) {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: id
    }
    PlanService.removeGame(data).then(function () {
      getGames();
    })
  }




  // var _planData = angular.copy(vm.planData);

  //     delete _planData.month;

  var getGames = function () {
    var planData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      // month: '2017.09',
      show_team: 'B'
    };

    PlanService.plans(planData).then(function (res) {
      // console.log('All games', res);
      plans = res.data.plans;
      vm.filterGames();
    });
  };
  getGames();
  
  // // 날짜 변경
  // if ($stateParams.date) {
  //   $scope.$parent.base.commonData.date = $stateParams.date;
  // }

  // // ViewModel
  // const vm = this;
      
  // $scope.trainStyle = 'target';

  // /**
  //  * API 호출 시 parameter 로 사용할 변수
  //  */

  // vm.getInjuryData = $scope.$parent.base.getInjuryData;
  // vm.setInjuryData = $scope.$parent.base.setInjuryData;


  // vm.setTrainingData = $scope.$parent.base.trainingData;
  // console.log('$scope.$parent.base.trainingData : ', $scope.$parent.base.trainingData);
  // vm.metaData = $scope.$parent.base.trainingMetaData;
  // // vm.metaData.timeObj = vm.setTrainingData.time;
  // vm.setMurlData = $scope.$parent.base.setMurlData;
  // vm.removeMurlData = $scope.$parent.base.removeMurlData;

  // //사용자 정보
  // let userInfo = vm.appContext.userInfo;
  // console.log('userInfo : ', userInfo);
  // let userBasicInfo = {
  //   login_id: vm.appContext.userInfo.login_id,
  //   uuid: vm.appContext.userInfo.uuid
  // }
  // // vm.trainingData.team_name = userInfo.team_name;

  // $scope.injuryPageInit = function() {
  //   //팀 전체 선수 목록 조회
  //   console.log('start : ', userBasicInfo);
  //   PlayerService.getPlayers(userBasicInfo).then(function(data){
  //     vm.players = data.players;
  //     setPage();
  //   });
  // }

  // //팀전체 선수 최신 부상 정보 조회
  // function setPage(){
  //   vm.getInjuryData.user_id = null;
  //   vm.getInjuryData.date = null;
  //   console.log('vm.getInjuryData : ',vm.getInjuryData);
  //   AnalysisService.getInjury(vm.getInjuryData).then(function(data){
  //     vm.playersInjuryInfo = [];

  //     console.log('getInjury', data);
  //     $scope.playerTotal = 0;
  //     $scope.playerNormal = 0;
  //     $scope.playerRecovery = 0;
  //     $scope.playerCare = 0;
  //     $scope.playerOperation = 0;
  //     $scope.playerWounded = 0;

  //     for(let i = 0;i < vm.players.length;i++){
  //       let user_id = +(vm.players[i].user_id);
  //       let idx = _.findIndex(
  //         data.data,
  //         {
  //           'user_id': user_id
  //         }
  //       );

  //       if(idx == -1){
  //         $scope.playerNormal++;
  //       }else{
  //         if (data.data[idx].state_id === 1) {
  //           $scope.playerNormal++;
  //         }
  //         if (data.data[idx].state_id === 2) {
  //           $scope.playerCare++;
  //         }
  //         if (data.data[idx].state_id === 3) {
  //           $scope.playerRecovery++;
  //         }
  //         if (data.data[idx].state_id === 4) {
  //           $scope.playerOperation++;
  //         }

  //       }

  //       $scope.playerTotal++;

  //     }
  //     $scope.playerWounded = $scope.playerTotal - $scope.playerNormal;
  //   });
  // }





  // /**
  //  * select 변경시 값 적용
  //  */
  // //훈련 정보가 개신 될 때
  // $scope.$watch('base.trainingData', function(newVal, oldVal){
  //   vm.setTrainingData = $scope.$parent.base.trainingData;
  //   console.log('$scope.$parent.base.trainingData : ', $scope.$parent.base.trainingData);
  //   vm.metaData = $scope.$parent.base.trainingMetaData;
  //   // vm.metaData.timeObj = vm.setTrainingData.time;
  //   vm.setMurlData = $scope.$parent.base.setMurlData;
  // });

  // // 팀 1단계 변경
  // $scope.$watch('recordTraining.metaData.team1', function(newVal, oldVal) {
  //   if (newVal && !newVal.is_last) {
  //     PlanService.getTeams({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.metaData.teams2 = data.list;
  //         vm.metaData.team2 = vm.metaData.teams2[0];
  //       });
  //     });
  //   } else {
  //     if (newVal) {
  //       vm.setTrainingData.team_id = newVal.id;
  //     }

  //     vm.metaData.teams2 = null;
  //     vm.metaData.teams3 = null;
  //   }
  // });


  // // 팀 2단계 변경
  // $scope.$watch('recordTraining.metaData.team2', function(newVal, oldVal) {
  //   if (newVal && !newVal.is_last) {
  //     PlanService.getTeams({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.metaData.teams3 = data.list;
  //         vm.metaData.team3 = vm.metaData.teams3[0];
  //       });
  //     });
  //   } else {
  //     if (newVal) {
  //       vm.setTrainingData.team_id = newVal.id;
  //     }

  //     vm.metaData.teams3 = null;
  //   }
  // });

  // // 팀 3단계 변경
  // $scope.$watch('recordTraining.metaData.team3', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.team_id = newVal.id;
  //   }
  // });

  // // 경기장 1단계 변경
  // $scope.$watch('recordTraining.metaData.stadium1', function(newVal, oldVal) {
  //   if (newVal && !newVal.is_last) {
  //     PlanService.getStadiums({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.metaData.stadiums2 = data.list;
  //         vm.metaData.stadium2 = vm.metaData.stadiums2[0];
  //       });
  //     });
  //   }
  // });

  // // 경기장 2단계 변경
  // $scope.$watch('recordTraining.metaData.stadium2', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.stadium_id = newVal.id;

  //     // 날씨 정보 불러오기
  //     vm.getWeather();
  //   }
  // });


  // // // 경기장 2단계 변경
  // // $scope.$watch('recordGame.selectedStadium2', function(newVal, oldVal) {
  // //   if (newVal) {
  // //     vm.gameInfoData.stadium_id = newVal.id;
  // //
  // //     // 날씨 정보 불러오기
  // //     vm.getWeather();
  // //   }
  // // });

  // /**
  //  * 동작 기능
  //  */
  // // 날씨 정보 불러오기
  // vm.getWeather = function() {
  //   //recordTraining.metaData.stadium2
  //   // console.log(vm.teamRecordTraining)

  //   const address = vm.metaData.stadium1.name + ' ' + vm.metaData.stadium2.name;


  //   let lat;
  //   let lng;
  //   // 지오코딩
  //   console.log('address **** ',address);
  //   PlanService.geocode(address).then(function(data) {
  //     if (data.results && data.results.length) {
  //       lat = data.results[0].geometry.location.lat;
  //       lng = data.results[0].geometry.location.lng;

  //       let gridObj = PlanService.dfsXyConv('toXY', lat, lng);

  //       // 기상청 날씨정보 가져오기
  //       PlanService.getWeather(gridObj.nx, gridObj.ny).then(function(data) {
  //         let items = data.response.body.items.item;

  //         // 하늘상태(날씨)
  //         let sky = _.find(items, {
  //           category: 'SKY'
  //         });

  //         if (sky) {
  //           if (sky.obsrValue == 1) {
  //             vm.metaData.weather_temp = '맑음';
  //           } else if (sky.obsrValue == 2) {
  //             vm.metaData.weather_temp = '구름조금';
  //           } else if (sky.obsrValue == 3) {
  //             vm.metaData.weather_temp = '구름많음';
  //           } else if (sky.obsrValue == 4) {
  //             vm.metaData.weather_temp = '흐림';
  //           }
  //         }

  //         console.log('vm.weather', vm.weather);

  //         // 습도
  //         let reh = _.find(items, {
  //           category: 'REH'
  //         });
  //         if (reh) {
  //           vm.gameInfoData.humidity = reh.obsrValue;
  //         }

  //         // 기온
  //         let t1h = _.find(items, {
  //           category: 'T1H'
  //         });
  //         if (t1h) {
  //           vm.gameInfoData.temperature = t1h.obsrValue;
  //         }

  //         // 풍속(바람)
  //         let wsd = _.find(items, {
  //           category: 'WSD'
  //         });
  //         if (wsd) {
  //           vm.gameInfoData.wind = wsd.obsrValue;
  //         }
  //       });
  //     }
  //   });
  // };




















  // // 장비 변경
  // $scope.$watch('recordTraining.metaData.equipment', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.equipment_id = newVal.id;
  //   }
  // });

  // // 훈련 목표 변경
  // $scope.$watch('recordTraining.metaData.target', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.target_id = newVal.id;
  //   }
  // });

  // // 훈련 계획 변경
  // $scope.$watch('recordTraining.metaData.plan', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.plan_id = newVal.id;
  //   }
  // });

  // // 훈련 내용 변경
  // $scope.$watch('recordTraining.metaData.movement', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.movement_id = newVal.id;
  //   }
  // });

  // // 웨이트 변경
  // $scope.$watch('recordTraining.metaData.weight', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.weight_id = newVal.id;
  //   }
  // });

  // // 워밍업/쿨다운 변경
  // $scope.$watch('recordTraining.metaData.wc', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.wc_id = newVal.id;
  //   }
  // });

  // // 코디네이션 변경
  // $scope.$watch('recordTraining.metaData.coord', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.setTrainingData.coord_id = newVal.id;
  //   }
  // });

  // /**
  //  * 동작 기능
  //  */
  // // 코칭포인트 입력
  // vm.inputPoint = function(type) {
  //   let point = vm.setTrainingData.point || '';

  //   switch (type) {
  //     case 'stadium':
  //       point += '운동장 : ';
  //       if (vm.metaData.stadium2) {
  //         point += vm.metaData.stadium2.name;
  //       } else {
  //         point += vm.metaData.stadium1.name;
  //       }
  //       point += '\n';
  //       vm.metaData.weather = vm.metaData.weather_temp;
  //       break;

  //     case 'equipment':
  //       point += '장비 : ';
  //       point += vm.metaData.equipment.name;
  //       point += '\n';
  //       break;

  //     case 'target':
  //       point += '훈련목표 : ';
  //       point += vm.metaData.target.name;
  //       point += '\n';
  //       break;

  //     case 'plan':
  //       point += '훈련계획 : ';
  //       point += vm.metaData.plan.name;
  //       point += '\n';
  //       break;

  //     case 'movement':
  //       point += '훈련내용 : ';
  //       point += vm.metaData.movement.name;
  //       point += ' ' + +vm.setTrainingData.movement_time + '분';
  //       point += '\n';
  //       break;

  //     case 'weight':
  //       point += '웨이트 : ';
  //       point += vm.metaData.weight.name;
  //       point += ' ' + +vm.setTrainingData.weight_time + '분';
  //       point += '\n';
  //       break;

  //     case 'wc':
  //       point += '전후운동 : ';
  //       point += vm.metaData.wc.name;
  //       point += ' ' + +vm.setTrainingData.wc_time + '분';
  //       point += '\n';
  //       break;

  //     case 'coord':
  //       point += '코디네이션 : ';
  //       point += vm.metaData.coord.name;
  //       point += ' ' + +vm.setTrainingData.coord_time + '분';
  //       point += '\n';
  //       break;
  //   }

  //   vm.setTrainingData.point = point;
  // };

  // $scope.$on('trainingStart', function(e, entryParams) {
  //   vm.record('first_time',entryParams);

  // });

  // // 기록
  // vm.record = function(type, entryParams) {
  //   console.log('vm.setTrainingData : ', vm.setTrainingData);

  //   if (!vm.setTrainingData.date || !vm.setTrainingData.time) {
  //     toastr.error('훈련 일자와 시각은 필수 입력 항목입니다.');
  //     return;
  //   }
  //   vm.setTrainingData.progress_time = $scope.$parent.base.commonData.progressTime;
  //   PlanService.setTraining(vm.setTrainingData).then(function(data) {
  //     if (data.result === 'SUC') {
  //       toastr.success('저장되었습니다.');
  //     }
  //   });
  // };

  // //메뉴 이동
  // vm.moveTrainingTab = function(e,mode) {
  //   var $ul = $(e.currentTarget).siblings('.inner').find('ul');
  //   var _unit = 361;
  //   var currentPos = $ul.css('margin-left');
  //   currentPos = currentPos ? parseInt(currentPos) : 0;
  //   if(mode == 'next'){
  //     if( (($ul.find('li').size()-1) * _unit / 2 - _unit) <= Math.abs(currentPos) ){
  //     }else{
  //       // $ul.stop().animate({'margin-left':currentPos - _unit},300);
  //       $ul.css({'margin-left':currentPos - _unit});
  //     }
  //   }else{
  //     if(currentPos >= 0){
  //     }else{
  //       // $ul.stop().animate({'margin-left':currentPos + _unit},300);
  //       $ul.css({'margin-left':currentPos + _unit});
  //     }
  //   }
  // };

  // // 동영상 생성/수정
  // vm.setMurl = function() {
  //   console.log('set Murl :', vm.setTrainingData);
  //   console.log('set Murl :', vm.setMurlData);
  //   if (!vm.setTrainingData.training_id) {
  //     toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 훈련을 시작해주십시오');
  //     return;
  //   }

  //   if (!vm.setMurlData.url) {
  //     toastr.error('동영상 URL을 입력해주십시오');
  //     return;
  //   }

  //   if(!vm.setMurlData.title) {
  //     toastr.error('동영상 제목을 입력해주십시오');
  //     return;
  //   }

  //   // 유튜브 동영상의 경우 동영상 url 변경
  //   // 예) https://www.youtube.com/watch?v=aSIkQ8USdWc => https://www.youtube.com/embed/aSIkQ8USdWc
  //   if (vm.setMurlData.url.match('youtube.com')) {
  //     if (!vm.setMurlData.url.match('\/embed\/')) {   // 이미 embed URL 인 경우 제외
  //       let urlId = vm.setMurlData.url.split('=')[1];
  //       vm.setMurlData.url = 'https://www.youtube.com/embed/' + urlId;
  //     }
  //   } else if (vm.setMurlData.url.match('youtu.be')) {  // 예) https://youtu.be/aSIkQ8USdWc
  //     let urlSplitLen = vm.setMurlData.url.split('/').length;
  //     let urlId = vm.setMurlData.url.split('/')[urlSplitLen - 1];
  //     vm.setMurlData.url = 'https://www.youtube.com/embed/' + urlId;
  //   }

  //   let setMurlData = angular.copy(vm.setMurlData);
  //   setMurlData.game_id = null;
  //   PlanService.setMurl(setMurlData).then(function(data) {
  //     if (data.murl_id) {
  //       toastr.success('저장되었습니다.')
  //       vm.setMurlData.title = null;
  //       vm.setMurlData.url = null;
  //       $scope.$parent.base.getTraining();
  //     }
  //   });
  // };

  // //동영상 삭제
  // vm.viewMediaId = '';
  // vm.removeMurl = function(id) {
  //   vm.removeMurlData.murl_id = id;
  //   PlanService.removeMurl(vm.removeMurlData).then(function(data) {
  //     if(data.result == 'SUC'){
  //       toastr.success('삭제되었습니다.')
  //       vm.setMurlData.title = null;
  //       vm.setMurlData.url = null;
  //       if(vm.viewMediaId == id){
  //         let el = angular.element("#viewMedia");
  //         el.attr('src', '');
  //       }
  //       $scope.$parent.base.getTraining();
  //     }
  //   });
  // }

  // vm.displayMedia = function(id, url){
  //   // vm.viewMedia = 'https://www.youtube.com/watch?v=ADq3QLntd5Y';
  //   vm.viewMediaId = id;
  //   let el = angular.element("#viewMedia");
  //   el.attr('src', url);
  // }

  // /**
  //  * 페이지 로딩시 실행
  //  */
  // // 경기,훈련 정보 목록
  // if ($scope.$parent.base.planData.login_id && $scope.$parent.base.planData.uuid) {
  //   PlanService.plans($scope.$parent.base.planData).then(function(data) {
  //     console.log('plans', data);
  //     $scope.$parent.base.plans = data.plans;

  //     let day = +(angular.copy($scope.$parent.base.commonData.date).substr(8, 2));
  //     // 오늘 날짜 훈련 정보 받아오기
  //     let todayTraining = _.find(data.plans, {
  //       'type': '훈련',
  //       'day': day
  //     });
  //     if (todayTraining) {
  //       $scope.$parent.base.setTrainingId(todayTraining.id);
  //       $scope.$parent.base.getTraining();
  //     }
  //   });
  // }

  // console.log('훈련화면 로딩 완료');
}

export default {
  name: 'TrainingCtrl',
  fn: TrainingCtrl
};
